@file:OptIn(InternalResourceApi::class)

package mifos_mobile.feature.savings_account.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mifos_mobile.feature.savings_account.generated.resources/"

internal val Res.string.feature_savings_withdraw_remarks_label: StringResource by lazy {
      StringResource("string:feature_savings_withdraw_remarks_label", "feature_savings_withdraw_remarks_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4398, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4174, 58),
      ))
    }

internal val Res.string.feature_savings_withdraw_request_failed: StringResource by lazy {
      StringResource("string:feature_savings_withdraw_request_failed", "feature_savings_withdraw_request_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4613, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4369, 79),
      ))
    }

internal val Res.string.feature_savings_withdraw_request_failed_message: StringResource by lazy {
      StringResource("string:feature_savings_withdraw_request_failed_message", "feature_savings_withdraw_request_failed_message", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4465, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4233, 135),
      ))
    }

internal val Res.string.feature_savings_withdraw_request_successful: StringResource by lazy {
      StringResource("string:feature_savings_withdraw_request_successful", "feature_savings_withdraw_request_successful", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4829, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4589, 91),
      ))
    }

internal val Res.string.feature_savings_withdraw_request_successful_message: StringResource by
    lazy {
      StringResource("string:feature_savings_withdraw_request_successful_message", "feature_savings_withdraw_request_successful_message", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4689, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4449, 139),
      ))
    }

internal val Res.string.feature_savings_withdraw_request_withdraw: StringResource by lazy {
      StringResource("string:feature_savings_withdraw_request_withdraw", "feature_savings_withdraw_request_withdraw", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 4921, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4681, 69),
      ))
    }

internal val Res.string.feature_savings_withdraw_submit: StringResource by lazy {
      StringResource("string:feature_savings_withdraw_submit", "feature_savings_withdraw_submit", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 5253, 55),
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4693, 55),
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4509, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4813, 51),
        ResourceItem(setOf(LanguageQualifier("gu"), ), "${MD}values-gu/strings.commonMain.cvr", 6369, 67),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 6293, 71),
        ResourceItem(setOf(LanguageQualifier("hu"), ), "${MD}values-hu/strings.commonMain.cvr", 4845, 55),
        ResourceItem(setOf(LanguageQualifier("in"), ), "${MD}values-in/strings.commonMain.cvr", 4609, 47),
        ResourceItem(setOf(LanguageQualifier("kn"), ), "${MD}values-kn/strings.commonMain.cvr", 7065, 67),
        ResourceItem(setOf(LanguageQualifier("ml"), ), "${MD}values-ml/strings.commonMain.cvr", 7669, 87),
        ResourceItem(setOf(LanguageQualifier("mr"), ), "${MD}values-mr/strings.commonMain.cvr", 6393, 71),
        ResourceItem(setOf(LanguageQualifier("ms"), ), "${MD}values-ms/strings.commonMain.cvr", 4541, 47),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 4701, 47),
        ResourceItem(setOf(LanguageQualifier("si"), ), "${MD}values-si/strings.commonMain.cvr", 6861, 95),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 4709, 51),
      ))
    }

internal val Res.string.feature_savings_withdraw_three: StringResource by lazy {
      StringResource("string:feature_savings_withdraw_three", "feature_savings_withdraw_three", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 5309, 42),
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4749, 42),
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4557, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4865, 42),
        ResourceItem(setOf(LanguageQualifier("gu"), ), "${MD}values-gu/strings.commonMain.cvr", 6437, 42),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 6365, 42),
        ResourceItem(setOf(LanguageQualifier("hu"), ), "${MD}values-hu/strings.commonMain.cvr", 4901, 42),
        ResourceItem(setOf(LanguageQualifier("in"), ), "${MD}values-in/strings.commonMain.cvr", 4657, 42),
        ResourceItem(setOf(LanguageQualifier("kn"), ), "${MD}values-kn/strings.commonMain.cvr", 7133, 42),
        ResourceItem(setOf(LanguageQualifier("ml"), ), "${MD}values-ml/strings.commonMain.cvr", 7757, 42),
        ResourceItem(setOf(LanguageQualifier("mr"), ), "${MD}values-mr/strings.commonMain.cvr", 6465, 42),
        ResourceItem(setOf(LanguageQualifier("ms"), ), "${MD}values-ms/strings.commonMain.cvr", 4589, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 4749, 42),
        ResourceItem(setOf(LanguageQualifier("si"), ), "${MD}values-si/strings.commonMain.cvr", 6957, 42),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 4761, 42),
      ))
    }

internal val Res.string.feature_savings_withdraw_topbar_title: StringResource by lazy {
      StringResource("string:feature_savings_withdraw_topbar_title", "feature_savings_withdraw_topbar_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 5352, 85),
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4792, 69),
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4600, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4908, 85),
        ResourceItem(setOf(LanguageQualifier("gu"), ), "${MD}values-gu/strings.commonMain.cvr", 6480, 129),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 6408, 97),
        ResourceItem(setOf(LanguageQualifier("hu"), ), "${MD}values-hu/strings.commonMain.cvr", 4944, 97),
        ResourceItem(setOf(LanguageQualifier("in"), ), "${MD}values-in/strings.commonMain.cvr", 4700, 77),
        ResourceItem(setOf(LanguageQualifier("kn"), ), "${MD}values-kn/strings.commonMain.cvr", 7176, 153),
        ResourceItem(setOf(LanguageQualifier("ml"), ), "${MD}values-ml/strings.commonMain.cvr", 7800, 193),
        ResourceItem(setOf(LanguageQualifier("mr"), ), "${MD}values-mr/strings.commonMain.cvr", 6508, 129),
        ResourceItem(setOf(LanguageQualifier("ms"), ), "${MD}values-ms/strings.commonMain.cvr", 4632, 85),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 4792, 77),
        ResourceItem(setOf(LanguageQualifier("si"), ), "${MD}values-si/strings.commonMain.cvr", 7000, 149),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 4804, 93),
      ))
    }

internal val Res.string.feature_savings_withdraw_two: StringResource by lazy {
      StringResource("string:feature_savings_withdraw_two", "feature_savings_withdraw_two", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 5438, 40),
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4862, 40),
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4678, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4994, 40),
        ResourceItem(setOf(LanguageQualifier("gu"), ), "${MD}values-gu/strings.commonMain.cvr", 6610, 40),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 6506, 40),
        ResourceItem(setOf(LanguageQualifier("hu"), ), "${MD}values-hu/strings.commonMain.cvr", 5042, 40),
        ResourceItem(setOf(LanguageQualifier("in"), ), "${MD}values-in/strings.commonMain.cvr", 4778, 40),
        ResourceItem(setOf(LanguageQualifier("kn"), ), "${MD}values-kn/strings.commonMain.cvr", 7330, 40),
        ResourceItem(setOf(LanguageQualifier("ml"), ), "${MD}values-ml/strings.commonMain.cvr", 7994, 40),
        ResourceItem(setOf(LanguageQualifier("mr"), ), "${MD}values-mr/strings.commonMain.cvr", 6638, 40),
        ResourceItem(setOf(LanguageQualifier("ms"), ), "${MD}values-ms/strings.commonMain.cvr", 4718, 40),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 4870, 40),
        ResourceItem(setOf(LanguageQualifier("si"), ), "${MD}values-si/strings.commonMain.cvr", 7150, 40),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 4898, 40),
      ))
    }

internal val Res.string.feature_savings_withdraw_withdrawal_date: StringResource by lazy {
      StringResource("string:feature_savings_withdraw_withdrawal_date", "feature_savings_withdraw_withdrawal_date", setOf(
        ResourceItem(setOf(LanguageQualifier("ar"), ), "${MD}values-ar/strings.commonMain.cvr", 5479, 76),
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 4903, 64),
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 4719, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5035, 68),
        ResourceItem(setOf(LanguageQualifier("gu"), ), "${MD}values-gu/strings.commonMain.cvr", 6651, 116),
        ResourceItem(setOf(LanguageQualifier("hi"), ), "${MD}values-hi/strings.commonMain.cvr", 6547, 100),
        ResourceItem(setOf(LanguageQualifier("hu"), ), "${MD}values-hu/strings.commonMain.cvr", 5083, 76),
        ResourceItem(setOf(LanguageQualifier("in"), ), "${MD}values-in/strings.commonMain.cvr", 4819, 72),
        ResourceItem(setOf(LanguageQualifier("kn"), ), "${MD}values-kn/strings.commonMain.cvr", 7371, 96),
        ResourceItem(setOf(LanguageQualifier("ml"), ), "${MD}values-ml/strings.commonMain.cvr", 8035, 112),
        ResourceItem(setOf(LanguageQualifier("mr"), ), "${MD}values-mr/strings.commonMain.cvr", 6679, 124),
        ResourceItem(setOf(LanguageQualifier("ms"), ), "${MD}values-ms/strings.commonMain.cvr", 4759, 72),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 4911, 68),
        ResourceItem(setOf(LanguageQualifier("si"), ), "${MD}values-si/strings.commonMain.cvr", 7191, 112),
        ResourceItem(setOf(LanguageQualifier("sw"), ), "${MD}values-sw/strings.commonMain.cvr", 4939, 72),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_savings_withdraw_remarks_label", Res.string.feature_savings_withdraw_remarks_label)
  map.put("feature_savings_withdraw_request_failed", Res.string.feature_savings_withdraw_request_failed)
  map.put("feature_savings_withdraw_request_failed_message", Res.string.feature_savings_withdraw_request_failed_message)
  map.put("feature_savings_withdraw_request_successful", Res.string.feature_savings_withdraw_request_successful)
  map.put("feature_savings_withdraw_request_successful_message", Res.string.feature_savings_withdraw_request_successful_message)
  map.put("feature_savings_withdraw_request_withdraw", Res.string.feature_savings_withdraw_request_withdraw)
  map.put("feature_savings_withdraw_submit", Res.string.feature_savings_withdraw_submit)
  map.put("feature_savings_withdraw_three", Res.string.feature_savings_withdraw_three)
  map.put("feature_savings_withdraw_topbar_title", Res.string.feature_savings_withdraw_topbar_title)
  map.put("feature_savings_withdraw_two", Res.string.feature_savings_withdraw_two)
  map.put("feature_savings_withdraw_withdrawal_date", Res.string.feature_savings_withdraw_withdrawal_date)
}
